import getLocalityPingData from '../locality/getLocalityPingData';
import logger from '../log';
import racedPromise from '../common/utils/racedPromise';
import transformToPrimingData from './transformToPrimingData';
import updateTimeout from './updateTimeout';
import { AgentInput, EMPTY_PROBE, PrimingData } from './interfaces';
import { addDuration } from '../common/utils/duration';
import { mergeProbeUrls } from '../locality/probeUrls';

const log = logger.getLogger(__filename);

const handleNon11Agent = async (input: AgentInput): Promise<PrimingData> => {
  const {
    chunk: { vals },
    config,
    primingData
  } = input;
  const timeout = updateTimeout(input);
  if (config.requestProbeUrls && primingData.info.contentId) {
    const probe = await racedPromise({
      // Get Ping Data
      callback: (): void => {
        addDuration({ vals, key: 'ping' });
      },
      exceptionCallback: e => {
        log.debug('Fetch Urls failed', e as Record<string, unknown>);
      },
      promise: getLocalityPingData(primingData.info, input.probe),
      response: input.probe || EMPTY_PROBE,
      timeout
    });
    if (probe && probe.hasProbed && input.probe && input.probe.hasProbed) {
      const list = [...probe.probeUrls, ...input.probe.probeUrls];
      probe.probeUrls = mergeProbeUrls(list);
    }
    input.probe = probe;
  }
  log.trace('handleNon11Agent:', input);
  return transformToPrimingData(input);
};

export default handleNon11Agent;
